import { render, staticRenderFns } from "./ApprovalStatus.vue?vue&type=template&id=0fbe2c15"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbe2c15')) {
      api.createRecord('0fbe2c15', component.options)
    } else {
      api.reload('0fbe2c15', component.options)
    }
    module.hot.accept("./ApprovalStatus.vue?vue&type=template&id=0fbe2c15", function () {
      api.rerender('0fbe2c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/ApprovalStatus.vue"
export default component.exports